import { render, staticRenderFns } from "./DragDropAttachment.vue?vue&type=template&id=48098140&scoped=true&"
import script from "./DragDropAttachment.vue?vue&type=script&lang=js&"
export * from "./DragDropAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DragDropAttachment.vue?vue&type=style&index=0&id=48098140&prod&scoped=true&lang=css&"
import style1 from "./DragDropAttachment.vue?vue&type=style&index=1&id=48098140&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48098140",
  null
  
)

export default component.exports